import { render, staticRenderFns } from "./SaldosPage.vue?vue&type=template&id=c718925e&scoped=true"
import script from "./SaldosPage.vue?vue&type=script&lang=js"
export * from "./SaldosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c718925e",
  null
  
)

export default component.exports